import React, { useMemo } from 'react'
import { FancyButton } from '@ui'
import { ethers } from 'ethers'
import { useClaimMyRewards } from 'hooks/useClaimMyRewards'
import { WalletReady } from 'privy/WalletReady'

type ClaimMyRewardsButtonProps = {
    currentReward: ethers.BigNumber | undefined
    disabled?: boolean
    className?: string
    onSuccess?: () => void
    label?: string
    action: 'claim' | 'claimAndStake' | 'redirectToStake'
}

export const ClaimMyRewardsButton: React.FC<ClaimMyRewardsButtonProps> = ({
    currentReward,
    disabled,
    className,
    onSuccess,
    label,
    action,
}) => {
    const { claimReward, isLoading } = useClaimMyRewards()

    const hasRewards = useMemo(() => {
        return currentReward && !currentReward.isZero()
    }, [currentReward])

    const isDisabled = disabled || (!hasRewards && action !== 'redirectToStake') || isLoading

    return (
        <WalletReady>
            {({ getSigner }) => (
                <FancyButton
                    compact
                    cta
                    width="100%"
                    disabled={isDisabled}
                    spinner={isLoading}
                    className={className}
                    borderRadius="full"
                    onClick={() => {
                        if (action === 'redirectToStake') {
                            onSuccess?.()
                        } else {
                            claimReward({
                                getSigner,
                                source: 'ClaimRewardsPanel',
                                onSuccess,
                                action,
                            })
                        }
                    }}
                >
                    {isLoading
                        ? 'Claiming...'
                        : hasRewards
                          ? (label ?? 'Claim')
                          : 'No Rewards Available'}
                </FancyButton>
            )}
        </WalletReady>
    )
}
